import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { IConfigurationCardOrTable } from "src/app/domain/interfaces/configuration-data.interface";

@Component({
	selector: "app-table-create",
	templateUrl: "./table-create.component.html",
	styleUrls: ["./table-create.component.scss"]
})
export class TableCreateComponent {
	@Input() response: IConfigurationCardOrTable;
	@Output() eventFirstButton = new EventEmitter();
	@Output() eventRemoveButton = new EventEmitter();

	clear(): void {
		this.eventFirstButton.emit();
	}

	remover(element): void {
		this.eventRemoveButton.emit(element);
	}
}
